import { ParentCompany } from './ParentCompany';

export default ParentCompany;
